import React from 'react'
import { Redirect, withRouter } from "react-router-dom";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";

class SubDesigns extends React.Component {


    render() {
        const { designURL } = this.props.affiliates;

        return (
            <div>
                <Redirect to={designURL} />
            </div>
        );
    }
}


const mapDispatchToProps = (dispatch, props) => {
    return ({
        dispatch,
    });
};

const mapStateToProps = state => {
    return {
        affiliates: state.affiliates,
    }
};

export default injectIntl(withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(SubDesigns)));


// WEBPACK FOOTER //
// ./src/routes/subAffilate/SubDesigns.js